import { render, staticRenderFns } from "./help-tray-wrapper.component.vue?vue&type=template&id=efe3ff82&"
import script from "./help-tray-wrapper.component.vue?vue&type=script&lang=ts&"
export * from "./help-tray-wrapper.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports